import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
  color: (p) => p.palette.grey[700],
};

export const costInfoText: SxStyle = {
  fontSize: (p) => p.typography.caption,
  color: (p) => p.palette.grey[500],
};

export const description: SxStyle = {
  fontSize: (p) => p.typography.body4,
};

export const descriptionWithDifferentColor: SxStyle = {
  fontSize: (p) => p.typography.body4,
};
